import { render } from "./CommonSpacer.vue?vue&type=template&id=aa71a54e"
const script = {}

import "./CommonSpacer.vue?vue&type=style&index=0&id=aa71a54e&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__